import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "priceing" }

import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { RefreshLeft, Search } from '@element-plus/icons-vue'

import SelectOperator from '@/components/SelectOperator.vue'
import PricingTable from './components/PricingTable.vue'

import { defineComponent, ref, onMounted, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'Pricing',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showMoreQuery = ref(false)
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const priceTableRef = ref()
const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  // loadPriceing()
  priceTableRef.value?.loadPriceing()
}

const handleReset = async () => {
  fuzzyParams.value = {}
  await nextTick()
  priceTableRef.value?.loadPriceing()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, ver, operatorId } = params
  newParams = {
    id: id || undefined,
    ver: ver || undefined,
    operatorId: operatorId || undefined,
  }
  return newParams
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                  placeholder: _ctx.$t('Operation.priceID'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createVNode(PricingTable, {
      ref_key: "priceTableRef",
      ref: priceTableRef,
      "operator-id": fuzzyParams.value.operatorId,
      id: fuzzyParams.value.id
    }, null, 8, ["operator-id", "id"])
  ]))
}
}

})